var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEvent6(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4136 3.08502L9.84605 3.59667V23.4268C8.91886 22.9545 7.86886 22.6881 6.75132 22.6881C3.02412 22.6881 0 25.6702 0 29.3456C0 33.0209 3.02105 36.003 6.75132 36.003C10.4816 36.003 13.4904 32.9786 13.4904 29.3032V12.767L31.3557 10.2118V19.4608C30.4285 18.9854 29.3724 18.716 28.2518 18.716C24.5246 18.716 21.5004 21.6951 21.5004 25.3735C21.5004 29.0519 24.5215 32.0309 28.2518 32.0309C31.982 32.0309 35.0031 29.0519 35.0031 25.3735V0L13.4136 3.08502Z",
    fill: "#7A876B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvent6);
export default __webpack_public_path__ + "static/media/event-6.67968e3db07e3f5fec4e5c4862f11d87.svg";
export { ForwardRef as ReactComponent };